<template>
  <svg
    :width="width ? width : height ? height * (15 / 15) : 15"
    :height="height ? height : width ? width * (15 / 15) : 15"
    viewBox="0 0 15 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      transform="translate(1.5 1.5)"
      fill="none"
      fill-rule="evenodd"
    >
    <circle
      :stroke="iconColor"
      stroke-width="2"
      cx="6"
      cy="6"
      r="6"
    />
    <ellipse
      :fill="iconColor"
      cx="6"
      cy="6"
      rx="3"
      ry="2.9993"
    />
  </g>
  </svg>
</template>

<script>
export default {
  name: 'depart',
  props: {
    iconColor: {
      type: String,
      default: '#F94094',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
